import styled from '@emotion/styled';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

import Language from '../../../entity/Language';
import { SPACING_REGULAR } from '../../constant/spacing';
import { flexibleLayoutContainer } from '../../styleUtility/flexibleLayout';
import LfToBr from '../primitive/LfToBr';

type Props = {
  open: boolean;
  urlToId: string;
  language?: Language;
  onRequestClose: () => void;
  className?: string;
};

const TransitionToKaizenIdModal: FC<Props> = ({ open, urlToId, language, onRequestClose, className }) => {
  const redirectUrl = language === 'ja-JP' ? `${urlToId}/account_setting/new` : `${urlToId}/questionnaire/kaizen_ad_us`;

  return (
    <Dialog open={open} onClose={onRequestClose} className={className}>
      <DialogTitle>
        <FormattedMessage id="transition_to_kaizenid_dialog.title" />
      </DialogTitle>
      <DialogContent>
        <Text variant="body2">
          <FormattedMessage id="transition_to_kaizenid_dialog.description">
            {(text: string) => <LfToBr text={text} />}
          </FormattedMessage>
        </Text>
        <AlignCenter>
          <Button href={redirectUrl} target="_blank" onClick={onRequestClose}>
            <FormattedMessage id="transition_to_kaizenid_dialog.button" />
          </Button>
        </AlignCenter>
      </DialogContent>
      <DialogActions>
        <Button variant="text" size="large" onClick={onRequestClose}>
          <FormattedMessage id="transition_to_kaizenid_dialog.close" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const Text = styled(Typography)`
  margin-bottom: ${SPACING_REGULAR}px;
`;

const AlignCenter = styled('div')`
  ${flexibleLayoutContainer({ justifyContent: 'center' })}
`;

export default TransitionToKaizenIdModal;
